import { formatMoney, type PlannedTransfer, type ScheduleAccount } from '@k-management/shared';
import { formatDate } from '../../lib/format.js';

/** The transfers planned from the scadenzario (3.25), to confirm, change or remove. */
export function ScheduleTransfers({
  transfers,
  accounts,
  canEdit,
  busy,
  onNew,
  onEdit,
  onDelete,
  onDone,
}: {
  transfers: PlannedTransfer[];
  accounts: ScheduleAccount[];
  canEdit: boolean;
  busy: boolean;
  onNew: () => void;
  onEdit: (transfer: PlannedTransfer) => void;
  onDelete: (transfer: PlannedTransfer) => void;
  onDone: (transfer: PlannedTransfer) => void;
}) {
  if (transfers.length === 0 && !canEdit) return null;
  const alias = (code: string) => accounts.find((item) => item.code === code)?.alias ?? code;
  return (
    <div className="card stack">
      <div className="row between">
        <strong>Giroconti programmati</strong>
        {canEdit && (
          <button type="button" className="small" onClick={onNew} disabled={accounts.length < 2}>
            Programma un giroconto
          </button>
        )}
      </div>
      {transfers.length === 0 && <p className="muted small">Nessun giroconto programmato.</p>}
      {transfers.map((item) => (
        <div key={item.id} className="row between schedule-transfer">
          <span>
            <strong>{formatMoney(item.amount)}</strong> da {alias(item.fromCode)} a{' '}
            {alias(item.toCode)} entro il {formatDate(item.date)}
            {item.note ? <span className="muted"> — {item.note}</span> : null}
          </span>
          {canEdit && (
            <span className="row">
              {item.candidate && (
                <button
                  type="button"
                  className="small primary"
                  disabled={busy}
                  title="Collega il giroconto al movimento di banca e chiudilo"
                  onClick={() => onDone(item)}
                >
                  Conferma: movimento del {formatDate(item.candidate.bookingDate)}
                </button>
              )}
              <button type="button" className="small" disabled={busy} onClick={() => onEdit(item)}>
                Modifica
              </button>
              <button
                type="button"
                className="small danger"
                disabled={busy}
                onClick={() => onDelete(item)}
              >
                Elimina
              </button>
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
